var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 4.666,
    viewBox: "0 0 8 4.666"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M-6835.334-22003l-.667.668 4 4 4-4-.667-.668-3.333 3.334z",
    transform: "translate(6836 22003)"
  })));
};
export { SvgArrowDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjQuNjY2IiB2aWV3Qm94PSIwIDAgOCA0LjY2NiI+CiAgICA8cGF0aCBmaWxsPSIjMTkxOTE5IiBkPSJNLTY4MzUuMzM0LTIyMDAzbC0uNjY3LjY2OCA0IDQgNC00LS42NjctLjY2OC0zLjMzMyAzLjMzNHoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDY4MzYgMjIwMDMpIi8+Cjwvc3ZnPgo=";